"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _normalizeError = require("./normalizeError");

Object.keys(_normalizeError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _normalizeError[key];
    }
  });
});